module.exports = __webpack_public_path__ + "static/media/wrocaw-4767317_1920.d5891ee2.jpg";